/**
 * @generated SignedSource<<fcf4fda65334c34a061d18ca86326153>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReportFoundAssetInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  email: string;
  message?: string | null | undefined;
};
export type AssetReturnReportMutation$variables = {
  input: ReportFoundAssetInput;
};
export type AssetReturnReportMutation$data = {
  readonly reportFoundAsset: {
    readonly foundReport: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type AssetReturnReportMutation = {
  response: AssetReturnReportMutation$data;
  variables: AssetReturnReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReportFoundAssetPayload",
    "kind": "LinkedField",
    "name": "reportFoundAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FoundReport",
        "kind": "LinkedField",
        "name": "foundReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetReturnReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssetReturnReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f5de20fdac2505d93209a90c10d2f09",
    "id": null,
    "metadata": {},
    "name": "AssetReturnReportMutation",
    "operationKind": "mutation",
    "text": "mutation AssetReturnReportMutation(\n  $input: ReportFoundAssetInput!\n) {\n  reportFoundAsset(input: $input) {\n    foundReport {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "680340418af52edc3900886e2246bc01";

export default node;
